<template>
  <b-card class="rounded-lg">
    <report-header
      :title="$t('ledger_rep_daily')"
      :scope-label="scopeLabel"
      :can-company="canCompany"
      :company="company"
      @company="company = $event; load()"
      @print="printReport"
    />
    <b-form-input
      v-model="date"
      type="date"
      class="mb-1 ledger-report-date"
      @change="load"
    />
    <div
      v-if="loading"
      class="text-center py-3"
    >
      <b-spinner />
    </div>
    <template v-else-if="report">
      <h5>{{ $t('ledger_rep_tills') }}</h5>
      <article
        v-for="till in report.tills || []"
        :key="till.account && till.account.id"
        class="ledger-report-card"
      >
        <strong>{{ till.account && till.account.name }}</strong>
        <div class="ledger-num">
          {{ money(till.opening_balance) }} → {{ money(till.closing_balance) }}
        </div>
        <div
          v-for="entry in till.entries || []"
          :key="entry.id"
          class="small"
        >
          {{ entry.entry_type === 'debit' ? $t('ledger_rep_in') : $t('ledger_rep_out') }}
          {{ money(entry.amount) }} · {{ entry.description }}
        </div>
      </article>
      <h5 class="mt-1">
        {{ $t('ledger_rep_custody') }}
      </h5>
      <article
        v-for="row in report.custody || []"
        :key="row.wallet && row.wallet.id"
        class="ledger-report-card"
      >
        <strong>{{ row.wallet && row.wallet.employee_name }}</strong>
        <div class="ledger-num">
          {{ money(row.closing_balance) }}
        </div>
      </article>
      <h5 class="mt-1">
        {{ $t('ledger_journals_title') }}
      </h5>
      <div
        v-for="journal in report.journals || []"
        :key="journal.id"
      >
        <b-link :to="{ name: 'ledger-journals-view', params: { id: journal.id } }">
          {{ journal.entry_number }}
        </b-link>
        <span class="ledger-num"> {{ money(journal.total) }}</span>
      </div>
      <div
        v-if="report.totals"
        class="ledger-num mt-1 font-weight-bold"
      >
        {{ $t('ledger_assets_total') }} {{ report.totals.journals_count }} · {{ money(report.totals.journals_total) }}
      </div>
    </template>
  </b-card>
</template>

<script>
import { BCard, BFormInput, BSpinner, BLink } from 'bootstrap-vue'
import { getDailyReport } from '@/api/accounting/financialReports'
import { oneFrom } from '@/utils/ledger'
import ReportHeader from './ReportHeader.vue'
import reportMixin from './reportMixin'

export default {
  name: 'DailyReport',
  components: { BCard, BFormInput, BSpinner, BLink, ReportHeader },
  mixins: [reportMixin],
  mounted() { this.load() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getDailyReport({ date: this.date, ...this.scopeParams })
        this.report = oneFrom(res)
      } catch (error) {
        this.toastError(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.ledger-num { font-variant-numeric: tabular-nums; }
.ledger-report-date { max-width: 12rem; }
.ledger-report-card { border-bottom: 1px solid #eee; padding: 0.75rem 0; }
</style>
